import { Skeleton, Stack } from "@mui/material";
import DashboardGrid from "./DashboardGrid";

type DashboardPageSkeletonProps = {
  includeFilters?: boolean;
};

export function DashboardPageSkeleton({
  includeFilters = false,
}: DashboardPageSkeletonProps) {
  return (
    <Stack gap={3} sx={{ p: 2 }}>
      {includeFilters && <DashboardFiltersSkeleton />}

      <DashboardPageDataSkeleton />
    </Stack>
  );
}

function DashboardFiltersSkeleton() {
  return (
    <DashboardGrid>
      {Array.from({ length: 4 }, (_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={56}
          sx={{
            animationDelay: `${index * 90}ms`,
            borderRadius: 1,
            width: "100%",
          }}
        />
      ))}
    </DashboardGrid>
  );
}

export function DashboardPageDataSkeleton() {
  return (
    <>
      <DashboardGrid>
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height={132}
            sx={{
              animationDelay: `${index * 90}ms`,
              borderRadius: 1,
            }}
          />
        ))}
      </DashboardGrid>

      {Array.from({ length: 3 }, (_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          height={376}
          sx={{
            animationDelay: `${index * 120}ms`,
            borderRadius: 1,
          }}
        />
      ))}
    </>
  );
}
